/*
  Пересчёт итоговой суммы сертификата: цена выбранного номинала * количество.
  Формат денег берём из настроек магазина, чтобы сумма выглядела так же,
  как везде на витрине.

  Всё внутри guard'а: если секция стоит на странице дважды, тег скрипта тоже
  выполнится дважды, и объявленные снаружи const упали бы с ошибкой переобъявления.
*/

if (!customElements.get('certificates-amount')) {
  const MONEY_PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;
  const THOUSANDS_PATTERN = /(\d)(?=(\d\d\d)+(?!\d))/g;
  const CENTS_IN_UNIT = 100;
  const DECIMALS_FULL = 2;
  const DECIMALS_NONE = 0;
  const MIN_QUANTITY = 1;

  const MONEY_RULES = {
    amount: { decimals: DECIMALS_FULL, thousands: ',', decimal: '.' },
    amount_no_decimals: { decimals: DECIMALS_NONE, thousands: ',', decimal: '.' },
    amount_with_comma_separator: { decimals: DECIMALS_FULL, thousands: '.', decimal: ',' },
    amount_no_decimals_with_comma_separator: { decimals: DECIMALS_NONE, thousands: '.', decimal: ',' },
    amount_with_apostrophe_separator: { decimals: DECIMALS_FULL, thousands: "'", decimal: '.' },
    amount_with_space_separator: { decimals: DECIMALS_FULL, thousands: ' ', decimal: ',' },
    amount_no_decimals_with_space_separator: { decimals: DECIMALS_NONE, thousands: ' ', decimal: ',' },
  };

  /**
   * Форматирует сумму в копейках по шаблону money_format магазина.
   * Возвращает null для незнакомого шаблона, чтобы вызывающий код оставил
   * отрисованную сервером цену вместо мусора на экране.
   *
   * @param {number} cents
   * @param {string} format
   * @returns {string|null}
   */
  function formatMoney(cents, format) {
    const match = format.match(MONEY_PLACEHOLDER);
    const rules = match ? MONEY_RULES[match[1]] : null;

    if (!rules) {
      console.warn(`certificates-amount: неизвестный формат денег "${format}", сумма не пересчитана`);
      return null;
    }

    const amount = (cents / CENTS_IN_UNIT).toFixed(rules.decimals);
    const [units, fraction] = amount.split('.');
    const groupedUnits = units.replace(THOUSANDS_PATTERN, `$1${rules.thousands}`);

    return format.replace(MONEY_PLACEHOLDER, fraction ? groupedUnits + rules.decimal + fraction : groupedUnits);
  }

  customElements.define(
    'certificates-amount',
    class CertificatesAmount extends HTMLElement {
      connectedCallback() {
        this.denominations = Array.from(this.querySelectorAll('[data-certificates-price]'));
        this.quantityInput = this.querySelector('[data-certificates-quantity]');
        this.total = this.querySelector('[data-certificates-total]');
        this.recipientForm = this.querySelector('recipient-form');
        this.moneyFormat = this.dataset.moneyFormat;

        if (!this.total || !this.moneyFormat || this.denominations.length === 0) return;

        this.denominations.forEach((input) => input.addEventListener('change', this.onDenominationChange.bind(this)));
        if (this.quantityInput) {
          this.quantityInput.addEventListener('change', this.onSelectionChange.bind(this));
        }
      }

      /**
       * Новый номинал - это выбор другого товара, а не изменение текущего:
       * количество возвращаем к одному, чтобы в корзину не ушли, например,
       * три сертификата по 150 вместо одного, который человек только что выбрал.
       */
      onDenominationChange() {
        if (this.quantityInput && this.quantityInput.value !== String(MIN_QUANTITY)) {
          this.quantityInput.value = String(MIN_QUANTITY);
          // Кнопки +/- держат своё состояние по событию input, а не по value
          this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        this.onSelectionChange();
      }

      onSelectionChange() {
        const selected = this.denominations.find((input) => input.checked);
        if (!selected) return;

        const price = parseInt(selected.dataset.certificatesPrice, 10);
        if (Number.isNaN(price)) return;

        // Подарочная форма темы завязана на id варианта — держим его актуальным
        if (this.recipientForm) this.recipientForm.dataset.productVariantId = selected.value;

        const parsedQuantity = parseInt(this.quantityInput ? this.quantityInput.value : '', 10);
        const quantity = Number.isNaN(parsedQuantity) ? MIN_QUANTITY : Math.max(parsedQuantity, MIN_QUANTITY);
        const formatted = formatMoney(price * quantity, this.moneyFormat);

        if (formatted === null) return;

        // Бегущие цифры общего модуля; без него сумма просто подставляется
        if (window.sbAnimateMoney) {
          window.sbAnimateMoney(this.total, formatted);
        } else {
          this.total.textContent = formatted;
        }
      }
    }
  );
}
